import { EventDirectiveModule } from '@b2c/common/directives/event/event.directive';
import { AnalyticsServiceModule } from '@b2c/common/services/analytics/analytics.service';
import { CalendarServiceModule } from '@b2c/common/services/calendar/calendar.service';
import { CartServiceModule } from '@b2c/common/services/cart/cart.service';
import { EventsServiceModule } from '@b2c/common/services/events/events.service';
import { HelpersServiceModule } from '@b2c/common/services/helpers/helpers.service';
import { ReviewsServiceModule } from '@b2c/common/services/reviews/reviews.service';
import { ThemesServiceModule } from '@b2c/common/services/themes/themes.service';
import angular from 'angular';

export const EventsReviewsControllerModule = angular.module('acme.view.events.reviews.controllers', [
  CartServiceModule,
  EventsServiceModule,
  CalendarServiceModule,
  HelpersServiceModule,
  ReviewsServiceModule,
  ThemesServiceModule,
  EventDirectiveModule,
  AnalyticsServiceModule
])

.controller('EventsReviewsController', ['$scope', '$state', '$filter', 'ReviewsSummaryData', 'AuthService', 'ReviewsService', 'CalendarService', 'AnalyticsService', 'HelpersService', function($scope, $state, $filter, ReviewsSummaryData, AuthService, ReviewsService, CalendarService, AnalyticsService, HelpersService) {

    $scope.eventsReviews = {

      date: '',
      dateParam: '',
      tenantId: '',
      reviewPage: 1,
      reviewLimit: 20,
      reviewLimitReached: false,
      averageRating: 0,
      model: [],
      summary: {},

      init: function() {
        this.tenantId = $state.params.tenantId;

        if ($state.params.date) {
          this.date = $filter('date')($state.params.date, 'EEEE, MMMM d, yyyy');
          this.dateParam = '?date=' + CalendarService.toISO8601($state.params.date);
        }


        if (ReviewsSummaryData.data && ReviewsSummaryData.data.success) {
          this.success.initReviews(ReviewsSummaryData);
        }else{
          this.error.initReviews(ReviewsSummaryData);
        }

        this.getReviews();

        $scope.$on('Review::EventClick', this.onReviewEventClick);
      },

      getReviews: function() {
        ReviewsService.api.tenant.list({
          tenantId: this.tenantId,
          page: this.reviewPage,
          pageSize: this.reviewLimit
        }).then(this.success.getReviews, this.error.getReviews);
      },

      moreReviews: function() {
        this.reviewPage += 1;
        AnalyticsService.event({
          name: 'Reviews::More',
          category: 'Events',
          label: 'Page: ' + this.reviewPage
        });
        this.getReviews();
      },

      getReviewLink: function(review) {
        return '/events/' + this.tenantId + '/detail/' + review.eventTemplateId+this.dateParam;
      },

      getAverageRating: function() {
        return $scope.eventsReviews.averageRating;
      },

      hasReviews: function() {
        return ($scope.eventsReviews.model instanceof Array && $scope.eventsReviews.model.length > 0);
      },

      success: {
        initReviews: function(response) {
          var summary = response.data.payload;
          $scope.eventsReviews.averageRating = summary.stars / summary.ratings;
        },

        getReviews: function(response) {
          var index,
              spliceArgs,
              self = $scope.eventsReviews,
              reviews = response.data.payload.reviews;

          if (reviews instanceof Array && reviews.length > 0) {
            index = self.reviewPage * self.reviewLimit;
            spliceArgs = [index, 0].concat(reviews);
            Array.prototype.splice.apply(self.model, spliceArgs);
          }else{
            self.reviewLimitReached = true;
          }

          AnalyticsService.event({
            name: 'Reviews::List',
            category: 'Events',
            label: 'Page: ' + self.reviewPage
          });

          self.summary = response.data.payload.summary;
        }
      },

      error: {
        initReviews: function(response) {},
        getReviews: function(response) {}
      },

      onReviewEventClick: function(e, data) {
        HelpersService.setHref($scope.eventsReviews.getReviewLink(data.review) + HelpersService.addDonationParams());
      }

    };

    $scope.eventsReviews.init();

}]).name;
